<template>
  <div class="dashboard">
    <div class="preview">
      <LinksPre :editing="editing"/>
    </div>

    <down-menu
      @change="setEdit">
      <Tabs @changeTab="changeTab"/>
      <style-section v-if="selectedTab=='Estilos'"></style-section>
      <content-section v-if="selectedTab=='Contenido'"></content-section>
      <div v-if="selectedTab=='Cuenta'">
        <div>
          https://misred.es/{{userName}}
        </div>
        <b-button @click="logOut()"> Log out</b-button>
      </div>
    </down-menu>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations} from 'vuex'
import LinksPre from "@/components/LinksPre"
import Tabs from "@/components/containers/Tabs.vue"
import DownMenu from "@/components/DownMenu"
import ContentSection from './Dashboard/ContentSection.vue'
import StyleSection from './Dashboard/StyleSection.vue'



export default {
  name: 'dashboard',
  components:{
    LinksPre,
    DownMenu,
    ContentSection,
    StyleSection,
    Tabs
  },
  data(){
    return {
      dropFile:{},
      editing:false,
      selectedTab:"Contenido",
      buttonTextColor:"None",
      gradientClasses:[
        'linear-gradient(45deg, #283E51, #4B79A1)',//'gray',
        'linear-gradient(25deg, #ff9068, #fd746c)',//'salmon',
        'linear-gradient(25deg, #64b3f4, #c2e59c)',//'greenBlue',
        'linear-gradient(to right, #8DC26F, #76b852)',//'green',
      ],
      
    }
  },
  computed:{
    ...mapGetters([
      'links',
      'userName',
      'style',
      'getColorsArray'
    ])
  },
  methods:{
    ...mapActions([
      'getLinks',
      'getImage',
      'getStyle',
      'saveLinkChange',
    ]),
    ...mapMutations([
      'indexOrder',
      'setBtnShape',
      'setGradient',
      'setBtnFill',
      'fillWithDemoLinks'
    ]),
    changeTab(tab){
      this.selectedTab = tab
    },
    setEdit(value){
      this.editing = value
    },
    logOut(){
      window.localStorage.removeItem('mr-jwt')
      this.$router.push("/login");
    },
    reSaveForError(error){
      console.log(error);
      // this.saveLinkChange()
    },
  },
  async mounted(){
    this.getImage(this.userName)
    this.getStyle(this.userName)
    this.getLinks(this.userName).then(()=>{
      if (this.links.length == 0){
        this.fillWithDemoLinks()
      }
    })
  },
}
</script>

<style scoped lang="scss">
label{
    font-weight: bold;
}
.dashboard{
  align-content: center;
}

.sideways{
  width: 100vw;
  min-height: 100vh;
  display:flex;
}
.mg-v-20{
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.manager{
  flex:5;
  border-right: solid 1px #aaa;

}

.preview{
  flex:4;
  display:flex;
  min-height: 100vh;
}
#mobile{
 margin:auto;
 background:gray;
 width: 33vh;
 height: 70vh;
 min-height: 315px;
 min-width: 150px;
 border-radius: 6vh;
 overflow-y: scroll;
 border: solid #4f5867;
}

h2{
  margin:0 auto;
}
.demoContainer{
  margin: 16px auto;
  display:flex;
  justify-content: space-evenly;
}
.smooth{
  border-radius: 100vw;
}
.sharp{
  border-radius:0;
}

</style>
